import React from 'react';
import styled from 'styled-components';

export default function SubTitle(props) {
  return <Container {...props} />;
}

const Container = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: #2b3674;
`;
